var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { View } from "./view";
import LocalStorageService from "../../services/localStorage";
import { useBranchesGetAll } from "../../fnx/branches/branchesGetAll";
import { deleteEntityClearData } from "../../store/delete/actions";
import { position, typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import showToast from "../../services/toast";
import { useBranchesPost } from "../../fnx/branches/branchesPost";
import { useBranchesPatch } from "../../fnx/branches/branchesPatch";
import { showErrorToast } from "../../fnx/showError";
import { menuItem, optionSelect, selectValueDefault } from "./branches.Dto";
import { useTranslation } from "react-i18next";
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
export var BranchesAdmin = function () {
    var dispatch = useDispatch();
    var t = useTranslation().t;
    var _a = useState([]), listBranches = _a[0], setListBranches = _a[1];
    var _b = useState(false), trigger = _b[0], setTrigger = _b[1];
    var _c = useState(false), triggerPost = _c[0], setTriggerPost = _c[1];
    var _d = useState(false), triggerPatch = _d[0], setTriggerPatch = _d[1];
    var _e = useState(""), idBranches = _e[0], setIdBranches = _e[1];
    var _f = useState(), valueName = _f[0], setValueName = _f[1];
    var _g = useState(), valueCode = _g[0], setValueCode = _g[1];
    var _h = useState({
        data: {
            clientId: "",
        },
    }), bodyRequest = _h[0], setBodyRequest = _h[1];
    var _j = useState(false), openModal = _j[0], setOpenModal = _j[1];
    var _k = useState(false), openModalConfirm = _k[0], setOpenModalConfirm = _k[1];
    var _l = useState(false), openModalCloneConfirm = _l[0], setOpenModalCloneConfirm = _l[1];
    var clientId = React.useState(lsLogin.getUserLoginStored().clientId)[0];
    var _m = useState(false), isUpdate = _m[0], setIsUpdate = _m[1];
    var _o = useState(null), itemModal = _o[0], setitemModal = _o[1];
    var _p = useState({
        Id: "",
        Name: "",
        Code: "",
    }), dataForm = _p[0], setDataForm = _p[1];
    var _q = useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _q[0], setSeeToast = _q[1];
    var _r = useBranchesGetAll(trigger, clientId, valueName, valueCode), responseBranches = _r.responseBranches, errorBranches = _r.errorBranches, loadingBranches = _r.loadingBranches;
    var _s = useBranchesPost(triggerPost, bodyRequest), responseBranchesPost = _s.responseBranchesPost, errorBranchesPost = _s.errorBranchesPost, loadingBranchesPost = _s.loadingBranchesPost;
    var _t = useBranchesPatch(triggerPatch, bodyRequest, idBranches), responseBranchesPatch = _t.responseBranchesPatch, errorBranchesPatch = _t.errorBranchesPatch, loadingBranchesPatch = _t.loadingBranchesPatch;
    var _u = useSelector(function (state) { return ({
        responseDeleteEntity: state.DeleteEntity.responseDeleteEntity,
        loadingDeleteEntity: state.DeleteEntity.loadingDeleteEntity,
        errorDeleteEntity: state.DeleteEntity.errorDeleteEntity,
    }); }), responseDeleteEntity = _u.responseDeleteEntity, loadingDeleteEntity = _u.loadingDeleteEntity, errorDeleteEntity = _u.errorDeleteEntity;
    var callBranches = function () {
        setTrigger(!trigger);
    };
    useEffect(function () {
        callBranches();
    }, []);
    var callBranchesPost = function () {
        setTriggerPost(!triggerPost);
    };
    var callBranchesPatch = function () {
        setTriggerPatch(!triggerPatch);
    };
    /*Valida respuesta del getAll y mapea objetos*/
    useEffect(function () {
        if (responseBranches && (responseBranches === null || responseBranches === void 0 ? void 0 : responseBranches.length) > 0) {
            var listBranches_1 = responseBranches.map(function (item) { return ({
                id: item.id,
                codeLabel: "Name: ",
                code: item.name,
                typeLabel: "Codigo: ",
                type: item.code,
                fontSizeType: 11,
                clientId: item.clientId,
            }); });
            setListBranches(listBranches_1);
            setTrigger(false);
        }
        else if (responseBranches && (responseBranches === null || responseBranches === void 0 ? void 0 : responseBranches.length) == 0) {
            setTrigger(false);
            setListBranches([]);
        }
    }, [responseBranches]);
    /*Valida respuesta cuando ya se inserto el registro*/
    useEffect(function () {
        setTriggerPost(false);
        if (responseBranchesPost) {
            setSeeToast({
                show: true,
                message: "Creado con éxito",
                type: typeAlert.success,
            });
            setOpenModal(false);
        }
        callBranches();
    }, [responseBranchesPost]);
    /*Valida respuesta cuando ya se actualizo el registro*/
    useEffect(function () {
        setTriggerPost(false);
        if (responseBranchesPatch) {
            setSeeToast({
                show: true,
                message: "Registro actualizado con éxito",
                type: typeAlert.success,
            });
            setOpenModal(false);
        }
        callBranches();
    }, [responseBranchesPatch]);
    /*Muestra si tubo errores el GET ALL  de sucursales*/
    useEffect(function () {
        if (errorBranches) {
            showErrorToast(errorBranches, setSeeToast, t);
        }
    }, [errorBranches]);
    /*Muestra si tubo errores el POST de sucursales*/
    useEffect(function () {
        if (errorBranchesPost) {
            showErrorToast(errorBranchesPost, setSeeToast, t);
        }
    }, [errorBranchesPost]);
    /*Muestra si tubo errores el Patch de sucursales*/
    useEffect(function () {
        if (errorBranchesPatch) {
            showErrorToast(errorBranchesPatch, setSeeToast, t);
        }
    }, [errorBranchesPatch]);
    useEffect(function () {
        if (responseDeleteEntity) {
            setSeeToast({
                show: true,
                message: "Eliminado con éxito",
                type: typeAlert.success,
            });
            setOpenModal(false);
            dispatch(deleteEntityClearData());
            setTrigger(true);
        }
        else if (errorDeleteEntity) {
            setSeeToast({
                show: true,
                message: errorDeleteEntity === null || errorDeleteEntity === void 0 ? void 0 : errorDeleteEntity.message.message,
                type: typeAlert.error,
            });
        }
    }, [responseDeleteEntity, errorDeleteEntity]);
    var showEdit = function (row) {
        setDataForm(__assign(__assign({}, dataForm), { Id: row.id, Name: row.code, Code: row.type, Status: row.status, clientId: clientId }));
    };
    /*Submit para actualizar o agregar un registro*/
    var handleSubmitBranches = function (dataBranches) {
        if (isUpdate) {
            /*Se llena la informacion al momento de acutalizar*/
            /*Se crea objeto en base al body del api*/
            setBodyRequest({
                data: {
                    name: dataBranches.Name,
                    code: dataBranches.Code,
                    status: "1",
                    clientId: clientId,
                },
            });
            // Se asigna el id del ProjectType para a actualizar
            setIdBranches(dataForm.Id);
            /*Llamda al FNX para actualizar PATCH*/
            callBranchesPatch();
        }
        else {
            /*Se procede a crear un nuevo Registro*/
            /*Se crea objeto en base al body del api*/
            setBodyRequest({
                data: {
                    name: dataBranches.Name,
                    code: dataBranches.Code,
                    status: "1",
                    clientId: clientId,
                },
            });
            /*Llamada al FNX para crear Registro*/
            callBranchesPost();
        }
        setOpenModal(false);
    };
    var handleOpenModal = function () {
        setOpenModal(true);
    };
    var handleOpenModalConfirm = function () {
        setOpenModalConfirm(true);
    };
    var handleOpenModalCloneConfirm = function () {
        setOpenModalCloneConfirm(true);
    };
    var handleCloseModal = function () {
        setOpenModal(false);
    };
    var onClickClearData = function (Data) {
        // Valida clean filtro y limpia los filtros
        if (Data.filter.type_filter === "empty") {
            setValueName(undefined);
            setValueCode(undefined);
        }
        // Llama a la consulta general sin filtros
        callBranches();
    };
    var onClickApplyFilter = function (Data) {
        if (Data.filter.type_filter === "name") {
            setValueName(Data.filter.filter_value);
            setValueCode(undefined);
        }
        else if (Data.filter.type_filter === "code") {
            setValueCode(Data.filter.filter_value);
            setValueName(undefined);
        }
        callBranches();
    };
    var handleSelectChange = function (event) {
        console.log("Event", event);
    };
    var handleOnClickAdd = function () {
        setIsUpdate(false);
        setOpenModal(true);
        setDataForm(__assign(__assign({}, dataForm), { Id: "", Name: "", code: "", status: "1", clientId: "" }));
    };
    var onClickContextsMenu = function (opt, card) {
        if (opt.id === "1") {
            // Opcion Editar
            setIsUpdate(true);
            setOpenModal(true);
            showEdit(card);
        }
        else if (opt.id === "2") {
            // Opcion eliminar
            // setitemModal(item);
            // setOpenModalConfirm(true);
            setSeeToast({
                show: true,
                message: "Operación no permitida!",
                type: typeAlert.warning,
            });
            setOpenModal(false);
        }
    };
    var clickView = function (view) {
        setitemModal(view);
    };
    var handleCloseModalConfirm = function () {
        setOpenModal(false);
        setOpenModalConfirm(false);
    };
    var handleCloseCloneModal = function () {
        setOpenModal(false);
        setOpenModalCloneConfirm(false);
    };
    /*Api que se ejecuta cuando el catalogo tiene la opcion
     * para eliminar registros*/
    var handleDelete = function () {
        setSeeToast({
            show: true,
            message: "Operación no permitida!",
            type: typeAlert.warning,
        });
        setOpenModal(false);
    };
    var handleClone = function () { };
    return (_jsxs(React.Fragment, { children: [seeToast.show &&
                showToast(position.topRight, seeToast.type, seeToast.message, function () { setSeeToast({ show: false, message: "", type: typeAlert.success }); }), _jsx(View, { title: "Sucursales", generalCatalogTitle: isUpdate ? "Modificar Sucursal" : "Agregar Sucursal", list: listBranches, openModal: openModal, openModalConfirm: openModalConfirm, openModalCloneConfirm: openModalCloneConfirm, loadingPost: null, dataForm: dataForm, modalTitle: itemModal === null || itemModal === void 0 ? void 0 : itemModal.title, clickView: clickView, onSubmit: handleDelete, onSubmitClone: handleClone, onClose: handleCloseModal, onCloseConfirm: handleCloseModalConfirm, onCloseCloneModal: handleCloseCloneModal, handleOpenModal: handleOpenModal, handleOpenModalConfirm: handleOpenModalConfirm, handleOpenModalCloneConfirm: handleOpenModalCloneConfirm, onFilterApply: onClickApplyFilter, onSaveData: handleSubmitBranches, onClickAdd: handleOnClickAdd, menuItem: menuItem, onClickContextMenu: onClickContextsMenu, onClickCancel: handleCloseModal, optionsSelect: optionSelect, onChangeSelect: handleSelectChange, onFilterEmpty: onClickClearData, selectValueDefault: selectValueDefault })] }));
};
export default BranchesAdmin;
